import { useEffect, useState } from 'react';

import { useConferenceState } from '../hooks/conferenceContext';
import {
  getErrorNotification,
  useNotification,
} from '../components/Notification';
import { getSearchParamValue } from '../helpers/path';
import { useMytaverse } from '../providers/MytaverseProvider';

export const useInitPrivateRoutesState = () => {
  const [initializing, setInitializing] = useState(true);

  const { setInitialState, resetState } = useConferenceState();

  useEffect(() => resetState, [resetState]);

  useEffect(() => {
    if (!initializing) return;

    const activeSpeakerDeviceId =
      localStorage.getItem('selectedSpeaker') || 'default';
    const activeCameraDeviceId = localStorage.getItem('selectedCamera') || '';
    const activeMicroDeviceId =
      localStorage.getItem('selectedMicrophone') || 'default';

    setInitialState({
      activeSpeakerDeviceId,
      activeCameraDeviceId,
      activeMicroDeviceId,
    });
    setInitializing(false);
  }, [initializing, setInitialState]);

  return initializing;
};

export const useHandleLoginError = () => {
  const { appTheme } = useMytaverse();
  const { showNotification } = useNotification();

  useEffect(() => {
    if (!appTheme) {
      return;
    }

    const errorDescription = decodeURIComponent(
      getSearchParamValue(location.search, 'error_description'),
    );

    if (errorDescription) {
      showNotification(
        getErrorNotification({
          message: errorDescription,
        }),
      );
    }
  }, [location.search, appTheme]);
};
